import React, { useState, useRef, useEffect } from "react";
import "./ChatContent.css";
import appURLs from "../../../appURL";
import getFetchConfig from "../../../utils/getFetchConfig";
import ChatItem from "./ChatItem";
import { useNavigate } from "react-router-dom";
// import { verify } from "jsonwebtoken";
import { CircularProgress } from "@mui/material";
import userVectorImage from '../../../assest/images/userVector.jpeg'

const ChatContent = ({ chatDetailsData, setInput, userData, sendMessage, input, loader, deleteMessage, selectedChat, checkOnlinestatus, ads_type, adsId, setSelectedFiles, selectedFiles, myMessages, setPreviewUrls, previewUrls, listData }) => {

  const navigate = useNavigate();

  const appURL = appURLs();
  const fetchConfig = getFetchConfig();
  const messagesEndRef = useRef(null);
  const [chat, setChat] = useState();
  const [msg, setMsg] = useState("");
  const [image, setImage] = useState(null);
  // const [selectedFiles, setSelectedFiles] = useState([]);
  // const [previewUrls, setPreviewUrls] = useState([]);
  const [showFullImage, setShowFullImage] = useState(null);
  const [imageUrl, setimageUrl] = useState('');
  const [mychatDetails, setmychatDetails] = useState();
  // const [selectedFiles, setSelectedFiles] = useState(null);
  const [wordCount, setWordCount] = useState(0);
  const textareaRef = useRef(null);
  const MAX_WORDS = 200;


  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const newPreviewUrls = files.map(file => URL.createObjectURL(file));

    setSelectedFiles(prevFiles => [...prevFiles, ...files]);
    setPreviewUrls(prevUrls => [...prevUrls, ...newPreviewUrls]);

    // Clear the input value to allow selecting the same file again
    e.target.value = '';
  };



  useEffect(() => {
  }, [myMessages])

  useEffect(() => {
    setmychatDetails(chatDetailsData);
  }, [chatDetailsData])

  const chatScrollRef = useRef();
  const prevMessageCount = useRef(myMessages.length);


  const colorList = {
    A: "#00FFFF",
    B: "#0000FF",
    C: "#FF8C00",
    D: "#FFD700",
    E: "#008000",
    F: "#FF00FF",
    G: "#DDA0DD",
    H: "#FF69B4",
    I: "#4B0082",
    J: "#00A86B",
    K: "#F0E68C",
    L: "#E6E6FA",
    M: "#000080",
    N: "#E0115F",
    O: "#808000",
    P: "#800080",
    Q: "#E0D0C6",
    R: "#FF0000",
    S: "#C0C0C0",
    T: "#00802bff",
    U: "#808000",
    V: "#D2691E",
    W: "#EE82EE",
    X: "#738678",
    Y: "#FFFF00",
    Z: "#000000",
  };


  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    let formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    formattedTime = formattedTime.replace(/^0/, '');
    return formattedTime;
  };

  useEffect(() => {
  }, [myMessages])

  const onStateChange = (e) => {
    setMsg(e.target.value);
  };

  const removeImage = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    setPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && input !== '' && previewUrls?.length == 0) {
      sendMessage();
    }
  };

  // const handleFileSelect = (event) => {
  //   setSelectedFiles(event.target.files);
  // };

  const userId = JSON.parse(localStorage.getItem("user"))?.userId;

  const handleSendMessage = () => {
    if (msg.trim() !== "") {
      const newMessage = {
        senderId: userId,
        content: msg,
        content_type: "text",
        status: "seen",
        timestamp: new Date().toISOString(),
      };
      setChat((prevChat) => [...prevChat, newMessage]);
      setMsg("");
    }
  };

  useEffect(() => {
    const scrollToBottom = () => {
      if (chatScrollRef.current) {
        chatScrollRef.current.scrollTo({
          top: chatScrollRef.current.scrollHeight,
          behavior: "smooth"
        });
      }
    };

    if (myMessages.length > prevMessageCount.current || myMessages) {
      scrollToBottom();
      prevMessageCount.current = myMessages.length;
    }
  }, [myMessages]);

  // Reverse the order of messages
  const reversedMessages = Array.isArray(myMessages) ? [...myMessages].reverse() : [];

  const getBackgroundColor = (initial) => {
    const color = colorList[initial.toUpperCase()] || "#FFFFFF"; // Default to white if the initial is not found
    return { backgroundColor: color };
  };

  const uploadFiles = async () => {
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => {
        formData.append('photos', file);
      });

      const token = localStorage.getItem("token");
      const headers = {};
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      // headers['Content-Type'] = 'multipart/form-data'; // Set Content-Type header

      const response = await fetch(`${appURL}/chat/upload-file`, {
        method: 'POST',
        body: formData,
        headers: headers,
      });

      if (!response.ok) {
        throw new Error('File upload failed');
      }

      const data = await response.json();
      const fileUrls = data.url; // Assuming the server returns an array of file URLs

      return fileUrls;
    } catch (error) {
      console.error('Error uploading files:', error);
      return [];
    }
  };

  // const titlebtn = (adsId, ads_type) => {
  //   console.log("adsID,,,,,,,ads_type",adsId,ads_type)
  //   switch (ads_type) {
  //     case "Buy & Sell":
  //       navigate(`/buySellDetails/${adsId}`);
  //       break;
  //     case "event":
  //       navigate(`/eventDetails/${adsId}`);
  //       break;
  //     case "rental":
  //       navigate(`/rentDetails/${adsId}`);
  //       break;
  //     case "babysitter & nannie":
  //       navigate(`/babySitterDetails/${adsId}`);
  //       break;
  //     case "job":
  //       navigate(`/jobDetails/${adsId}`);
  //       break;
  //     case "Local_biz & Service":
  //       navigate(`/localBizDetails/${adsId}`);
  //       break;
  //     default:
  //       return "/";
  //   }
  // };


  const titlebtn = (adsId, ads_type) => {
    const decodedType = decodeURIComponent(ads_type)
      .replace(/\+/g, " ")
      .trim();

    switch (decodedType) {
      case "Buy & Sell":
        navigate(`/buySellDetails/${adsId}`);
        break;

      case "event":
        navigate(`/eventDetails/${adsId}`);
        break;

      case "rental":
        navigate(`/rentDetails/${adsId}`);
        break;

      case "babysitter & nannie":
        navigate(`/babySitterDetails/${adsId}`);
        break;

      case "job":
        navigate(`/jobDetails/${adsId}`);
        break;

      case "Local_biz & Service":
        navigate(`/localBizDetails/${adsId}`);
        break;

      default:
        console.warn("No route matched for:", decodedType);
    }
  };




  useEffect(() => {
  }, [showFullImage])

  const handleImageClick = () => {
    setShowFullImage(!showFullImage);
  };
  const handleRemoveImage = (e, index) => {
    e.stopPropagation();
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    setPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
  };

  //   const handleKeyDown = (e) => {
  //   if (
  //     e.key === "Enter" &&
  //     !e.shiftKey &&
  //     (input.trim() !== "" || previewUrls?.length > 0)
  //   ) {
  //     e.preventDefault(); // prevent new line
  //     sendMessage();
  //   }
  // };

  // const handleInputChange = (e) => {
  //   let value = e.target.value;

  //   // Split words safely
  //   let words = value
  //     .trim()
  //     .split(/\s+/)
  //     .filter(Boolean);

  //   if (words.length > MAX_WORDS) {
  //     // Allow only first 200 words
  //     words = words.slice(0, MAX_WORDS);
  //     value = words.join(" ");
  //   }

  //   setInput(value);
  //   setWordCount(words.length);
  // };

  const handleInputChange = (e) => {
    const textarea = e.target;
    let value = textarea.value;

    let words = value.trim().split(/\s+/).filter(Boolean);

    if (words.length > MAX_WORDS) {
      words = words.slice(0, MAX_WORDS);
      value = words.join(" ");
    }

    setInput(value);
    setWordCount(words.length);

    // Auto resize logic
    textarea.style.height = "auto"; 
    textarea.style.height = textarea.scrollHeight + "px"; 
  };

  useEffect(() =>{
    if(input === '' && textareaRef.current){
textareaRef.current.style.height ='42px';
setWordCount(0);
    }
  },[input])

  // const handleKeyDown = (e) => {
  //   if (
  //     e.key === "Enter" &&
  //     !e.shiftKey &&
  //     (input.trim() !== "" || previewUrls.length > 0)
  //   ) {
  //     e.preventDefault();
  //     sendMessage();
  //   }
  // };
  const handleKeyDown = (e) => {
    if (
      e.key === "Enter" &&
      !e.shiftKey &&
      input.trim() !== "" &&
      wordCount <= MAX_WORDS
    ) {
      e.preventDefault();
      sendMessage();
    }
  };



  return (
    <>
      {<div className="main__chatcontent chat_box_wrap">
        {(loader) && <div className="loader-overlay">
          <CircularProgress />
        </div>}
        {((listData && (chatDetailsData?.messages !== null && chatDetailsData?.messages !== undefined)) || listData === undefined) && <div className="content__header">
          <div className="blocks">
            <div className="current-chatting-user">

              <div className="profile_img_header"
                onClick={() => {
                  titlebtn(adsId, ads_type);
                }}
              >
                <div className="profile_images">
                  {((chatDetailsData?.seller_id === (JSON.parse(localStorage.getItem("user"))?.userId) && (chatDetailsData?.buyer_image !== null && chatDetailsData?.buyer_image !== "null")) || (chatDetailsData?.seller_id !== (JSON.parse(localStorage.getItem("user"))?.userId) && (chatDetailsData?.seller_image !== null && chatDetailsData?.seller_image !== "null"))) ? (
                    <img src={chatDetailsData?.seller_id === (JSON.parse(localStorage.getItem("user"))?.userId) ? chatDetailsData?.buyer_image : chatDetailsData?.seller_image ? chatDetailsData?.seller_image : userData?.profile_img ? userData?.profile_img : userVectorImage} alt="seller" />
                  ) : (
                    <div className="seller_placeholder" style={getBackgroundColor(chatDetailsData?.seller_name ? chatDetailsData?.seller_name[0].toUpperCase() : '')}>
                      <p> {chatDetailsData?.seller_id === (JSON.parse(localStorage.getItem("user"))?.userId) ? chatDetailsData?.buyer_name[0] : chatDetailsData?.seller_name[0] ? chatDetailsData?.seller_name[0] : userData?.name ? userData?.name : ''} </p>
                    </div>
                  )}

                  {/* <img src={chatDetailsData.seller_image} alt="image altitude"/> */}
                </div>
                <div className="profile_section">
                  <p>{chatDetailsData?.seller_id === (JSON.parse(localStorage.getItem("user"))?.userId) ? chatDetailsData?.buyer_name : chatDetailsData?.seller_name ? chatDetailsData?.seller_name : userData?.name ? userData?.name : ''}</p>
                  <span className="profile-heading">{chatDetailsData?.ads_name}</span>

                  <h6 className={chatDetailsData?.status === 'active' ? "online" : "offline"}>
                    {chatDetailsData?.status === 'active' ? "online" : "offline"}
                  </h6>

                </div>
              </div>

            </div>
          </div>
          <div className="blocks">
            <div className="settings">
              {/* <button className="btn-nobg"> */}
              {/* <i className="fa fa-cog"></i> */}
              {/* </button> */}
            </div>
          </div>  
        </div>}
        <div className="chat_body">
          {((listData && (chatDetailsData?.messages !== null && chatDetailsData?.messages !== undefined)) || !listData) ? (
            <div className="content__body" ref={chatScrollRef}>
              <div className="chat__items">
                {myMessages?.map((message, index) => (
                  <ChatItem
                    key={index}
                    user={message?.user}
                    type={"text"}
                    msg={message.message}
                    timeStamp={formatTime(message.timeStamp)}
                    onDelete={() => deleteMessage(message.key)}
                    setShowFullImage={setShowFullImage}
                    setimageUrl={setimageUrl}
                  />
                ))}
              </div>
            </div>
          ) : (
            <>
              {
                (!loader || chatDetailsData?.messages === null) && <div style={{ display: 'flex', alignItems: 'center', 
                  justifyContent: 'center', flexDirection: 'column' , minHeight: '100vh',width: '100%',
                  padding:'20px'}}>
                  <img src="https://cdn.vectorstock.com/i/500p/30/21/data-search-not-found-concept-vector-36073021.avif" className="not-found-image"/>
                  <h3>No Chat Found!</h3>
                </div>
              }
            </>
          )}
        </div>
        <div className="content__footer">
          <div className="image-previews" style={{ display: 'flex' }}>
            {selectedFiles?.length > 0 && previewUrls.map((url, index) => (
              <div key={index} className="image-preview" style={{ position: 'relative', margin: '10px' }}>
                <img
                  src={url}
                  alt="Preview"
                  onClick={() => handleImageClick(index)}
                  style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                />
                <button
                  onClick={(e) => handleRemoveImage(e, index)}
                  style={{
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>

          {(showFullImage && imageUrl) && (
            <div
              onClick={() => { setShowFullImage(false); }}
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={imageUrl}
                alt="Full Preview"
                style={{ maxWidth: '90%', maxHeight: '90%' }}
              />
            </div>
          )}
          {((listData && (chatDetailsData?.messages !== null &&
            chatDetailsData?.messages !== undefined)) || !listData)
            &&
            //       <div className="sendNewMessage">
            //         <button className="addFiles" onClick={() => document.getElementById('fileInput').click()}>
            //           <i className="fa fa-plus"></i>
            //         </button>
            //         <input
            //           type="file"
            //           id="fileInput"
            //           style={{ display: 'none' }}
            //           onChange={handleFileSelect}
            //           multiple
            //         />
            //         {/* <input
            //           type="text"
            //           placeholder="Type a message here"
            //           onChange={e => setInput(e.target.value)}
            //           value={input}
            //           // onKeyPress={handleKeyPress}
            //            onKeyDown={handleKeyDown}
            //         /> */}
            //         {/* <textarea
            //   className={`chat-input ${wordCount > 200 ? "error" : ""}`}
            //   placeholder="Type a message here"
            //   value={input}
            //   onChange={handleInputChange}
            //   onKeyDown={handleKeyDown}
            //   rows={1}
            // />
            // {wordCount >= MAX_WORDS && (
            //   <p className="word-error">
            //     You can only type up to 200 words
            //   </p>
            // )} */}
            // <div className="message-input-wrapper">
            //   <textarea
            //     className={`chat-input ${wordCount > 200 ? "error" : ""}`}
            //     placeholder="Type a message here"
            //     value={input}
            //     onChange={handleInputChange}
            //     onKeyDown={handleKeyDown}
            //     rows={1}
            //   />

            //   <p className={`word-error ${wordCount >= 200 ? "show" : ""}`}>
            //     You can only type up to 200 words
            //   </p>
            // </div>



            //         <button
            //           className="btnSendMsg"
            //           id="sendMsgBtn"
            //           onClick={sendMessage}
            //           disabled={input === '' && previewUrls?.length == 0}
            //         >
            //           <i className="fa fa-paper-plane"></i>
            //         </button>
            //       </div>
            <div className="sendNewMessage">

              <button
                type="button"
                className="addFiles"
                onClick={() => document.getElementById("fileInput").click()}
              >
                <i className="fa fa-plus"></i>
              </button>

              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                onChange={handleFileSelect}
                multiple
              />

              <div className="message-input-wrapper">
                <textarea
                ref={textareaRef}
                  className={`chat-input ${wordCount > 200 ? "error" : ""}`}
                  placeholder="Type a message..."
                  value={input}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  rows={1}
                />

                {wordCount >= MAX_WORDS && (
                  <p className="word-error show">
                    You can only type up to 200 words
                  </p>
                )}
              </div>

              <button
                className="btnSendMsg"
                onClick={sendMessage}
                disabled={input.trim() === "" && previewUrls?.length === 0}
              >
                <i className="fa fa-paper-plane"></i>
              </button>

            </div>


          }

        </div>
      </div>}
    </>
  );
};

export default ChatContent;
